import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';

const ScrollToTop: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll to top smoothly
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <>
            {isVisible && (
                <div
                    onClick={scrollToTop}
                    className="fixed h-[40px] w-[40px] right-[15px] py-[11px] bottom-0 bg-[#404040] z-[999] rounded-t-[5px] text-center flex justify-center"
                    aria-label="Scroll to top"
                >
                    <FontAwesomeIcon icon={faChevronUp} className='text-[#fff] text-[11px] leading-3 font-extrabold' />
                </div>
            )}
        </>
    );
};

export default ScrollToTop; 